import LoggerService,{formatTrace} from '../../../services/LoggerService';
import INITIAL_STATE from './INITIAL_STATE';
import REDUCER_ACTIONS from './ACTIONS';

const LOG = LoggerService.getInstance();

const reducer = (
  state: any,
  action: any
) => {
	if (action.type === REDUCER_ACTIONS.SET_DIRECTIONS) {
		const {directions} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_DIRECTIONS',{directions}));
		return {...state,directions};
	}
	if (action.type === REDUCER_ACTIONS.SET_DIRECTION_POLES) {
		const {directionPoles} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_DIRECTION_POLES',{directionPoles}));
		return {...state,directionPoles};
	}
	if (action.type === REDUCER_ACTIONS.SET_SITES) {
		const {sites} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_SITES',{sites}));
		return {...state,sites};
	}
	if (action.type === REDUCER_ACTIONS.SET_FUNCTIONS) {
		const {functions} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_FUNCTIONS',{functions}));
		return {...state,functions};
	}
	if (action.type === REDUCER_ACTIONS.SET_SKILLS) {
		const {skills} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_SKILLS',{skills}));
		return {...state,skills};
	}
	if (action.type === REDUCER_ACTIONS.SET_PAGE) {
		const {page} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_PAGE',{page}));
		return {...state,page};
	}
	// return state;
	throw new Error(`No matching "${action.type}" action type`);
};

export {INITIAL_STATE};
export default reducer;
